import React from "react"
import styled, { css, keyframes } from "styled-components"
import { colors, fontFamily, fontWeight, fontSize } from "buoy-theme"
import { Paragraph } from "buoy-text"

const TooltipsVert = keyframes`
  from {
    opacity: .1;
    transform: translateY(-10px);
  }
`

const Button = styled.button`
  position: relative;
  font-family: ${fontFamily};
  font-weight: ${fontWeight.Light};
  font-size: 9px;
  color: ${colors.neutralDarkest};
  background-color: ${colors.neutralLightest};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 16px;
  height: 16px;
  appearance: none;
  outline: none;
  border: none;
  border-radius: 50%;
`

const TooltipMessage = styled(Paragraph)`
  position: absolute;
  text-align: left;
  bottom: 20px;
  font-family: ${fontFamily};
  font-weight: ${fontWeight.light};
  ${fontSize("bodySmall")};
  color: white;
  background-color: ${colors.neutralDark};
  border-radius: 4px;
  width: 230px;
  padding: 8px 12px;
  transition: opacity 0.3s;
  box-sizing: border-box;
  z-index: 1000;
  margin: 0 50%;
  right: -7px;

  ${props =>
    props.position.down &&
    css`
      bottom: unset;
      top: 20px;
    `};
  animation: ${TooltipsVert} 200ms ease;
`

const Tooltip = styled.div`
  position: relative;
  display: block;
  overflow: ${props => (props.show ? "visible" : "hidden")};
`

const TooltipButton = ({ onClick, buttonRef }) => (
  <Button type="button" onClick={onClick} innerRef={buttonRef}>
    ?
  </Button>
)

class TooltipContainer extends React.Component {
  state = {
    show: false,
    position: {
      down: false,
      x: null,
    },
  }

  onClick = () => {
    let pos = this.state.position
    this.setState({ show: !this.state.show, position: pos })
  }

  onHover = hoverState => {
    this.setState({ show: hoverState })
  }

  handleClickOutside = () => {
    this.setState({
      show: false,
      position: {
        down: false,
        x: null,
      },
    })
  }

  render() {
    return (
      <Tooltip
        show={this.state.show}
        onMouseEnter={() => this.onHover(true)}
        onMouseLeave={() => this.onHover(false)}
      >
        {this.state.show && (
          <TooltipMessage
            position={this.state.position}
            innerRef={m => (this.message = m)}
          >
            {this.props.message && this.props.message}
            {this.props.children}
          </TooltipMessage>
        )}
        <TooltipButton
          onClick={this.onClick}
          buttonRef={b => (this.button = b)}
        />
      </Tooltip>
    )
  }
}

export default TooltipContainer



// WEBPACK FOOTER //
// ./assets/common/components/Tooltip/index.js